import { render, staticRenderFns } from "./appointment.vue?vue&type=template&id=46244559&scoped=true"
import script from "./appointment.vue?vue&type=script&lang=js"
export * from "./appointment.vue?vue&type=script&lang=js"
import style0 from "./appointment.vue?vue&type=style&index=0&id=46244559&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46244559",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\vescort-platform-pc-website\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('46244559')) {
      api.createRecord('46244559', component.options)
    } else {
      api.reload('46244559', component.options)
    }
    module.hot.accept("./appointment.vue?vue&type=template&id=46244559&scoped=true", function () {
      api.rerender('46244559', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/softBusinessLogistics/appointment.vue"
export default component.exports